import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/our_vision_mission";

export default class OurVisionMission extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Our Vision Mission | ${this.trans("window-title")}`
    );
    this.scrollToTop();
  }
}
